import { createLoadingReducer } from './utils';

export default createLoadingReducer('PARAKEY_SETTINGS');
